export default "__VITE_ASSET__Da7$vJMQ__"